import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import useDebounce from '../../../hooks/use-debounce';
import {
  Button, Container, Input, Label,
} from './styles';

const TextFilterComponent = (props) => {
  const { api, column, colDef } = props;

  const [filterText, setFilterText] = useState('');
  const debouncedFilterText = useDebounce(() => filterText, 500, [filterText]);

  const updateFilter = async () => {
    await api.setColumnFilterModel(column.colId, {
      type: colDef.type,
      value: debouncedFilterText,
    });
    api.onFilterChanged();
  };

  const onChange = (event) => {
    setFilterText(event.target.value);
  };

  const onResetButtonClick = async () => {
    setFilterText('');
    await api.setColumnFilterModel(column.colId, null);
    api.onFilterChanged();
  };

  useEffect(() => {
    updateFilter();
  }, [debouncedFilterText, api]);

  return (
    <Container>
      <Label>{column.getColDef().headerName}</Label>
      <Input
        type="text"
        value={filterText}
        onChange={onChange}
      />
      <Button onClick={onResetButtonClick}>
        Reset filter
      </Button>
    </Container>
  );
};

TextFilterComponent.propTypes = {
  api: PropTypes.object.isRequired,
  column: PropTypes.object.isRequired,
  colDef: PropTypes.shape({
    type: PropTypes.string,
  }).isRequired,
};

export default TextFilterComponent;
